import { BrandKitGQL } from '@adflow/graphqlgen';
import { parseFonts } from '@adflow/utils';

import apolloClient from '../../apolloClient';

export async function loadAdvertiserFonts(businessEntityId: number) {
  const { error, data } = await apolloClient.query({
    query: BrandKitGQL.GET_ALL_FONTS_BY_OWNER,
    variables: { advertiserId: JSON.stringify(businessEntityId) },
    fetchPolicy: 'network-only',
  });
  if (error) {
    throw new Error('Could not load fonts for that advertiser.');
  }
  return data?.getFontFamiliesByOwner ? parseFonts(data.getFontFamiliesByOwner) : [];
}
